<template>
  <div class="catalog-item-create">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" class="catalog-item-create__modal">

      <md-dialog-content v-if="data">
        <md-button @click="clear()" class="md-icon-button catalog-item-create__button--close">
          <md-icon>close</md-icon>
        </md-button>

        <h3 class="catalog-item-create__title">Produkt bearbeiten</h3>
        <div class="catalog-item-create__content">
          <div class="catalog-item-create__field-wrapper--margin-r">
            <catalog-icon-select v-bind:icon.sync="data.icon" :selected="data.icon"></catalog-icon-select>
          </div>
          <form class="md-layout" @submit.prevent="submit">
            <md-field required>
              <label for="name">Bezeichnung</label>
              <md-input name="name" id="name" required v-model="data.name"/>
            </md-field>

            <md-field required>
              <label for="quantity">Quantität</label>
              <md-input name="quantity" id="quantity" v-model="data.quantity"/>
            </md-field>

            <div class="catalog-item-create__field-wrapper catalog-item-create__field-wrapper--small catalog-item-create__field-wrapper--margin-r">
              <md-field required>
                <label for="price">Preis</label>
                <md-input type="number" step="0.01" required name="price" id="price" min="0" v-model="data.price"/>
              </md-field>
            </div>

            <div class="catalog-item-create__field-wrapper catalog-item-create__field-wrapper--small">
              <md-field>
                <label for="mwst">MwSt.</label>
                <md-input type="number" step="0.01" name="mwst" id="mwst" v-model="data.mwst"/>
              </md-field>
            </div>

            <md-field>
              <md-select v-model="data.catalog_category_id" name="category" id="category" placeholder="Kategorie">
                <md-option v-for="category in categories" :value="category.id" :key="category.id">{{category.name}}</md-option>
              </md-select>
            </md-field>

            <div class="catalog-item-create__buttons">
              <button type="submit" :disabled="!validated" class="button catalog-item-create__button catalog-item-create__button--add">Speichern</button>
            </div>

          </form>

        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import CatalogIconSelect from './CatalogItemIconSelect'

    export default {
        name: 'CatalogItemEdit',
        components: {
            CatalogIconSelect
        },
        data() {
            return {
                data: null
            }
        },
        computed: {
            ...mapGetters('catalog', [
                'categories',
                'editItem'
            ]),
            showDialog: function() {
                return this.editItem != null
            },
            validated: function() {
                return (this.data.name && this.data.price && this.data.icon && this.data.catalog_category_id)
            }
        },
        mounted() {
            this.prepareData()
        },
        methods: {
            ...mapActions('catalog', [
                'updateItem',
                'resetItem'
            ]),
            clear: function() {
                this.resetItem()
            },
            prepareData: function() {
                this.data = JSON.parse(JSON.stringify(this.editItem))
                let mwst = parseFloat(this.data.mwst)
                if(mwst === 0.00) {
                    this.data.mwst = null
                } else {
                    let tmpMwst = mwst * 100
                    this.data.mwst = tmpMwst.toFixed(2)
                }
            },
            submit: async function() {
                await this.updateItem(this.data)
            }
        }
    }
</script>
